import { render, staticRenderFns } from "./TermCondition.vue?vue&type=template&id=80bda586&"
import script from "./TermCondition.vue?vue&type=script&lang=js&"
export * from "./TermCondition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports